(function($) {

	//
	$(document).ready(function() {
		//
		var $body = $('body');

		$body.on('click', '.accordion-toggle', function() {
			if($(this).parent('.accordion').hasClass('open')) {
				$(this).parent('.accordion').toggleClass('closing');
				$(this).siblings('.accordion-content').slideToggle(400, function() {
					$(this).parent('.accordion').removeClass('open');
					$(this).parent('.accordion').removeClass('closing');
				});
			} else {
				//
				$(this).parent('.accordion').toggleClass('opening');
				$(this).siblings('.accordion-content').slideToggle(400, function() {
					$(this).parent('.accordion').addClass('open');
					$(this).parent('.accordion').removeClass('opening');
				});
			}
		});
	})
})(window.jQuery);
